import * as React from 'react';
import Loader from '../../CustomViews/Pages/Loader/Loader';

export type FallbackType = NonNullable<React.ReactNode> | null;

export interface FallbackContextType {
    updateFallback: (fallback: FallbackType) => void;
}

export const FallbackContext = React.createContext<FallbackContextType>({
    updateFallback: () => { },
});

interface FabllbackProviderProps { }

const FabllbackProvider = (props: { children: React.ReactNode }) => {
    const [fallback, setFallback] = React.useState<FallbackType>(null);

    const updateFallback = React.useCallback((fallback: FallbackType) => {
        setFallback(() => fallback);
    }, []);

    const renderChildren = React.useMemo(() => {
        return props.children;
    }, [props.children]);

    return (
        <FallbackContext.Provider value={{ updateFallback }}>
            <React.Suspense fallback={<Loader />}>{renderChildren}</React.Suspense>
        </FallbackContext.Provider>
    );
};

export default FabllbackProvider;